import { INSTITUTION_INFO } from '@/config/constants';

// Static SEO data that mimics backend API response structure
export const staticSeoData = {
  success: true,
  message: "Static SEO data retrieved successfully",
  data: [
    {
      id: 1,
      name: "Home",
      slug: "home",
      language: "en",
      page_title: INSTITUTION_INFO.name,
      meta_title: `${INSTITUTION_INFO.name} | Heavy Equipment Operator Certification`,
      meta_description: "Leading heavy equipment training academy in India. Get certified in excavator, bulldozer, crane operation with hands-on training. Industry-recognized certification programs with 7+ years experience.",
      meta_keywords: "heavy equipment training, excavator certification, bulldozer training, crane operator course, earth movers academy, construction equipment training",
      og_title: `${INSTITUTION_INFO.name} | Heavy Equipment Certification`,
      og_description: "Professional heavy equipment training with industry certification. Join thousands of successful graduates.",
      og_image: "/images/home-og.jpg",
      twitter_title: INSTITUTION_INFO.name,
      twitter_description: "Get certified in heavy equipment operation with India's leading training academy",
      canonical_url: "https://earthmovers.com/",
      created_by: null,
      updated_by: null,
      is_deleted: false,
      createdAt: "2025-11-14T00:00:00.000Z",
      updatedAt: "2025-11-14T00:00:00.000Z"
    },
    {
      id: 2,
      name: "Training Courses",
      slug: "courses",
      language: "en",
      page_title: "Training Courses",
      meta_title: "Heavy Equipment Training Courses | Earth Movers Academy",
      meta_description: "Browse comprehensive heavy equipment training courses. Excavator, bulldozer, crane operator certification programs. Hands-on training with modern equipment and expert instructors.",
      meta_keywords: "heavy equipment courses, training programs, excavator course, bulldozer certification, crane training, operator certification, construction equipment courses",
      og_title: "Heavy Equipment Training Courses | Professional Certification",
      og_description: "Professional certification courses for heavy equipment operators. Learn from industry experts with hands-on training.",
      og_image: "/images/courses-og.jpg",
      twitter_title: "Heavy Equipment Training Courses",
      twitter_description: "Professional certification courses for heavy equipment operators",
      canonical_url: "https://earthmovers.com/courses",
      created_by: null,
      updated_by: null,
      is_deleted: false,
      createdAt: "2025-11-14T00:00:00.000Z",
      updatedAt: "2025-11-14T00:00:00.000Z"
    },
    {
      id: 3,
      name: "About Us",
      slug: "about-us",
      language: "en",
      page_title: "About Us",
      meta_title: `About ${INSTITUTION_INFO.name} | ${INSTITUTION_INFO.experience} Years Experience`,
      meta_description: `Learn about ${INSTITUTION_INFO.name}. Over ${INSTITUTION_INFO.experience} years of excellence in heavy equipment operator training and certification. Trusted by industry professionals nationwide with modern facilities.`,
      meta_keywords: "about earth movers, training academy history, heavy equipment school, certification authority, industry experience, training institute",
      og_title: `About ${INSTITUTION_INFO.name}`,
      og_description: "7+ years of excellence in heavy equipment training and certification with modern facilities and expert instructors",
      og_image: "/images/about-og.jpg",
      twitter_title: `About ${INSTITUTION_INFO.name}`,
      twitter_description: "7+ years of excellence in heavy equipment training",
      canonical_url: "https://earthmovers.com/about",
      created_by: null,
      updated_by: null,
      is_deleted: false,
      createdAt: "2025-11-14T00:00:00.000Z",
      updatedAt: "2025-11-14T00:00:00.000Z"
    },
    {
      id: 4,
      name: "Contact Us",
      slug: "contact-us",
      language: "en",
      page_title: "Contact Us",
      meta_title: `Contact ${INSTITUTION_INFO.name} | Enquire About Courses`,
      meta_description: `Get in touch with ${INSTITUTION_INFO.name}. Enquire about heavy equipment training courses, certification programs, admission process, and career opportunities. Call or visit us today.`,
      meta_keywords: "contact earth movers, course enquiry, training admission, heavy equipment school contact, certification enquiry, training institute contact",
      og_title: `Contact ${INSTITUTION_INFO.name}`,
      og_description: "Get in touch for course enquiries, admission information, and career opportunities",
      og_image: "/images/contact-og.jpg",
      twitter_title: `Contact ${INSTITUTION_INFO.name}`,
      twitter_description: "Get in touch for course enquiries and admission information",
      canonical_url: "https://earthmovers.com/contact",
      created_by: null,
      updated_by: null,
      is_deleted: false,
      createdAt: "2025-11-14T00:00:00.000Z",
      updatedAt: "2025-11-14T00:00:00.000Z"
    },
    {
      id: 5,
      name: "Gallery - Images",
      slug: "gallery-images",
      language: "en",
      page_title: "Training Gallery - Images",
      meta_title: "Training Gallery Images | Earth Movers Academy Facilities & Equipment",
      meta_description: "View photos of our heavy equipment training facilities, modern machinery, training sessions, and successful graduates. See our state-of-the-art equipment and campus facilities.",
      meta_keywords: "training gallery, heavy equipment photos, academy facilities, training equipment images, construction machinery photos, training campus",
      og_title: "Training Gallery Images | Earth Movers Academy",
      og_description: "View photos of our training facilities, equipment, and successful graduates",
      og_image: "/images/gallery-images-og.jpg",
      twitter_title: "Training Gallery Images",
      twitter_description: "View photos of our training facilities and equipment",
      canonical_url: "https://earthmovers.com/gallery/images",
      created_by: null,
      updated_by: null,
      is_deleted: false,
      createdAt: "2025-11-14T00:00:00.000Z",
      updatedAt: "2025-11-14T00:00:00.000Z"
    },
    {
      id: 6,
      name: "Gallery - Videos",
      slug: "gallery-videos",
      language: "en",
      page_title: "Training Gallery - Videos",
      meta_title: "Training Videos | Heavy Equipment Operation & Training Sessions",
      meta_description: "Watch training videos showcasing heavy equipment operation techniques, student training sessions, and equipment demonstrations. Learn about our practical training approach.",
      meta_keywords: "training videos, heavy equipment operation videos, training sessions, equipment demonstrations, practical training videos, construction equipment videos",
      og_title: "Training Videos | Earth Movers Academy",
      og_description: "Watch training videos and equipment demonstrations from our academy",
      og_image: "/images/gallery-videos-og.jpg",
      twitter_title: "Training Videos",
      twitter_description: "Watch training videos and equipment demonstrations",
      canonical_url: "https://earthmovers.com/gallery/videos",
      created_by: null,
      updated_by: null,
      is_deleted: false,
      createdAt: "2025-11-14T00:00:00.000Z",
      updatedAt: "2025-11-14T00:00:00.000Z"
    },
    {
      id: 7,
      name: "Privacy Policy",
      slug: "privacy-policy",
      language: "en",
      page_title: "Privacy Policy",
      meta_title: `Privacy Policy | ${INSTITUTION_INFO.name}`,
      meta_description: `Read our privacy policy to understand how ${INSTITUTION_INFO.name} collects, uses, and protects your personal information. Your privacy and data security are our priority.`,
      meta_keywords: "privacy policy, data protection, personal information, privacy rights, data security, earth movers privacy",
      og_title: `Privacy Policy | ${INSTITUTION_INFO.name}`,
      og_description: "Our commitment to protecting your privacy and personal information",
      og_image: "/images/privacy-og.jpg",
      twitter_title: "Privacy Policy",
      twitter_description: "Our commitment to protecting your privacy",
      canonical_url: "https://earthmovers.com/privacy-policy",
      created_by: null,
      updated_by: null,
      is_deleted: false,
      createdAt: "2025-11-14T00:00:00.000Z",
      updatedAt: "2025-11-14T00:00:00.000Z"
    },
    {
      id: 8,
      name: "Terms and Conditions",
      slug: "terms-conditions",
      language: "en",
      page_title: "Terms and Conditions",
      meta_title: `Terms and Conditions | ${INSTITUTION_INFO.name}`,
      meta_description: `Read the terms and conditions for ${INSTITUTION_INFO.name} courses, services, and website usage. Understand your rights and responsibilities as a student or website user.`,
      meta_keywords: "terms and conditions, terms of service, course terms, academy policies, student terms, website terms",
      og_title: `Terms and Conditions | ${INSTITUTION_INFO.name}`,
      og_description: "Terms and conditions for our courses, services, and website usage",
      og_image: "/images/terms-og.jpg",
      twitter_title: "Terms and Conditions",
      twitter_description: "Terms and conditions for our services",
      canonical_url: "https://earthmovers.com/terms-conditions",
      created_by: null,
      updated_by: null,
      is_deleted: false,
      createdAt: "2025-11-14T00:00:00.000Z",
      updatedAt: "2025-11-14T00:00:00.000Z"
    },
    {
      id: 9,
      name: "FAQ",
      slug: "faq",
      language: "en",
      page_title: "Frequently Asked Questions",
      meta_title: `FAQ | Heavy Equipment Training Questions | ${INSTITUTION_INFO.name}`,
      meta_description: `Find answers to frequently asked questions about heavy equipment training courses, admission process, certification, fees, and career opportunities at ${INSTITUTION_INFO.name}.`,
      meta_keywords: "FAQ, frequently asked questions, training questions, course information, admission FAQ, certification questions, heavy equipment training FAQ",
      og_title: `FAQ | ${INSTITUTION_INFO.name}`,
      og_description: "Find answers to frequently asked questions about our training courses and services",
      og_image: "/images/faq-og.jpg",
      twitter_title: "FAQ - Training Questions",
      twitter_description: "Find answers to frequently asked questions",
      canonical_url: "https://earthmovers.com/faq",
      created_by: null,
      updated_by: null,
      is_deleted: false,
      createdAt: "2025-11-14T00:00:00.000Z",
      updatedAt: "2025-11-14T00:00:00.000Z"
    }
  ],
  pagination: {
    page: 1,
    limit: 10,
    total: 4,
    totalPages: 1,
    hasNext: false,
    hasPrev: false
  },
  timestamp: new Date().toISOString()
};

// Hindi version
export const staticSeoDataHindi = {
  success: true,
  message: "Static SEO data retrieved successfully",
  data: [
    {
      id: 1,
      name: "होम",
      slug: "home",
      language: "hi",
      page_title: "अर्थ मूवर्स ट्रेनिंग एकेडमी",
      meta_title: "अर्थ मूवर्स ट्रेनिंग एकेडमी | हेवी इक्विपमेंट ऑपरेटर सर्टिफिकेशन",
      meta_description: "भारत की अग्रणी हेवी इक्विपमेंट ट्रेनिंग एकेडमी। एक्सकेवेटर, बुलडोजर, क्रेन ऑपरेशन में व्यावहारिक प्रशिक्षण के साथ प्रमाणित हों। 7+ वर्षों के अनुभव के साथ उद्योग-मान्यता प्राप्त प्रमाणन कार्यक्रम।",
      meta_keywords: "हेवी इक्विपमेंट ट्रेनिंग, एक्सकेवेटर सर्टिफिकेशन, बुलडोजर ट्रेनिंग, क्रेन ऑपरेटर कोर्स, अर्थ मूवर्स एकेडमी, निर्माण उपकरण प्रशिक्षण",
      og_title: "अर्थ मूवर्स ट्रेनिंग एकेडमी | हेवी इक्विपमेंट सर्टिफिकेशन",
      og_description: "उद्योग प्रमाणन के साथ व्यावसायिक हेवी इक्विपमेंट ट्रेनिंग। हजारों सफल स्नातकों में शामिल हों।",
      og_image: "/images/home-og-hi.jpg",
      twitter_title: "अर्थ मूवर्स ट्रेनिंग एकेडमी",
      twitter_description: "भारत की अग्रणी ट्रेनिंग एकेडमी के साथ हेवी इक्विपमेंट ऑपरेशन में प्रमाणित हों",
      canonical_url: "https://earthmovers.com/hi/",
      created_by: null,
      updated_by: null,
      is_deleted: false,
      createdAt: "2025-11-14T00:00:00.000Z",
      updatedAt: "2025-11-14T00:00:00.000Z"
    },
    {
      id: 2,
      name: "ट्रेनिंग कोर्सेज",
      slug: "courses",
      language: "hi",
      page_title: "ट्रेनिंग कोर्सेज",
      meta_title: "हेवी इक्विपमेंट ट्रेनिंग कोर्सेज | अर्थ मूवर्स एकेडमी",
      meta_description: "व्यापक हेवी इक्विपमेंट ट्रेनिंग कोर्सेज देखें। एक्सकेवेटर, बुलडोजर, क्रेन ऑपरेटर प्रमाणन कार्यक्रम। आधुनिक उपकरण और विशेषज्ञ प्रशिक्षकों के साथ व्यावहारिक प्रशिक्षण।",
      meta_keywords: "हेवी इक्विपमेंट कोर्सेज, ट्रेनिंग प्रोग्राम, एक्सकेवेटर कोर्स, बुलडोजर सर्टिफिकेशन, क्रेन ट्रेनिंग, ऑपरेटर सर्टिफिकेशन, निर्माण उपकरण कोर्स",
      og_title: "हेवी इक्विपमेंट ट्रेनिंग कोर्सेज | व्यावसायिक प्रमाणन",
      og_description: "हेवी इक्विपमेंट ऑपरेटरों के लिए व्यावसायिक प्रमाणन कोर्स। उद्योग विशेषज्ञों से व्यावहारिक प्रशिक्षण सीखें।",
      og_image: "/images/courses-og-hi.jpg",
      twitter_title: "हेवी इक्विपमेंट ट्रेनिंग कोर्सेज",
      twitter_description: "हेवी इक्विपमेंट ऑपरेटरों के लिए व्यावसायिक प्रमाणन कोर्स",
      canonical_url: "https://earthmovers.com/hi/courses",
      created_by: null,
      updated_by: null,
      is_deleted: false,
      createdAt: "2025-11-14T00:00:00.000Z",
      updatedAt: "2025-11-14T00:00:00.000Z"
    },
    {
      id: 3,
      name: "हमारे बारे में",
      slug: "about-us",
      language: "hi",
      page_title: "हमारे बारे में",
      meta_title: "अर्थ मूवर्स ट्रेनिंग एकेडमी के बारे में | 7+ वर्षों का अनुभव",
      meta_description: "अर्थ मूवर्स ट्रेनिंग एकेडमी के बारे में जानें। हेवी इक्विपमेंट ऑपरेटर प्रशिक्षण और प्रमाणन में 7+ वर्षों की उत्कृष्टता। आधुनिक सुविधाओं के साथ देशभर के उद्योग पेशेवरों द्वारा भरोसेमंद।",
      meta_keywords: "अर्थ मूवर्स के बारे में, ट्रेनिंग एकेडमी इतिहास, हेवी इक्विपमेंट स्कूल, प्रमाणन प्राधिकरण, उद्योग अनुभव, प्रशिक्षण संस्थान",
      og_title: "अर्थ मूवर्स ट्रेनिंग एकेडमी के बारे में",
      og_description: "आधुनिक सुविधाओं और विशेषज्ञ प्रशिक्षकों के साथ हेवी इक्विपमेंट प्रशिक्षण और प्रमाणन में 7+ वर्षों की उत्कृष्टता",
      og_image: "/images/about-og-hi.jpg",
      twitter_title: "अर्थ मूवर्स ट्रेनिंग एकेडमी के बारे में",
      twitter_description: "हेवी इक्विपमेंट प्रशिक्षण में 7+ वर्षों की उत्कृष्टता",
      canonical_url: "https://earthmovers.com/hi/about",
      created_by: null,
      updated_by: null,
      is_deleted: false,
      createdAt: "2025-11-14T00:00:00.000Z",
      updatedAt: "2025-11-14T00:00:00.000Z"
    },
    {
      id: 4,
      name: "संपर्क करें",
      slug: "contact-us",
      language: "hi",
      page_title: "संपर्क करें",
      meta_title: "अर्थ मूवर्स ट्रेनिंग एकेडमी से संपर्क करें | कोर्स पूछताछ",
      meta_description: "अर्थ मूवर्स ट्रेनिंग एकेडमी से संपर्क करें। हेवी इक्विपमेंट ट्रेनिंग कोर्स, प्रमाणन कार्यक्रम, प्रवेश प्रक्रिया, और करियर के अवसरों के बारे में पूछताछ करें। आज ही कॉल करें या हमसे मिलें।",
      meta_keywords: "अर्थ मूवर्स संपर्क, कोर्स पूछताछ, ट्रेनिंग प्रवेश, हेवी इक्विपमेंट स्कूल संपर्क, प्रमाणन पूछताछ, प्रशिक्षण संस्थान संपर्क",
      og_title: "अर्थ मूवर्स ट्रेनिंग एकेडमी से संपर्क करें",
      og_description: "कोर्स पूछताछ, प्रवेश जानकारी, और करियर के अवसरों के लिए संपर्क करें",
      og_image: "/images/contact-og-hi.jpg",
      twitter_title: "अर्थ मूवर्स ट्रेनिंग एकेडमी से संपर्क करें",
      twitter_description: "कोर्स पूछताछ और प्रवेश जानकारी के लिए संपर्क करें",
      canonical_url: "https://earthmovers.com/hi/contact",
      created_by: null,
      updated_by: null,
      is_deleted: false,
      createdAt: "2025-11-14T00:00:00.000Z",
      updatedAt: "2025-11-14T00:00:00.000Z"
    }
  ],
  pagination: {
    page: 1,
    limit: 10,
    total: 2,
    totalPages: 1,
    hasNext: false,
    hasPrev: false
  },
  timestamp: new Date().toISOString()
};